// extracted by mini-css-extract-plugin
export default {"baseStyles":"e9dQFJ"};